import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  background: #ffffff;

  padding: 12px 0px;
  border-bottom: 1px solid #f1f1f1;

  display: flex;
  justify-content: space-between;
  align-items: center;

  gap: 12px;

  &:hover {
    background: #fafafa;
  }
`;

export const IconWrapper = styled.div<{ active: boolean }>`
  width: 32px;
  height: 32px;
  background: ${props =>
    props.active ? props.theme.colors.primary.main : ' #e1e1e1'};

  border-radius: 6px;

  display: flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;

  svg {
    path {
      fill: #ffffff;
    }
  }
`;
